<template>
  <section
    class="bg-gradient-to-br from-slate-50 to-blue-50 rounded-xl p-6 lg:p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-slate-200"
  >
    <div class="relative overflow-hidden rounded-lg mb-6">
      <img
        :src="featuredArticle.imageBase64"
        :alt="featuredArticle.title"
        loading="lazy"
        class="w-full h-64 lg:h-80 object-cover transform hover:scale-105 transition-transform duration-500"
      />
      <div class="absolute inset-0 bg-gradient-to-t from-slate-900/20 to-transparent"></div>
    </div>
    <div class="space-y-4">
      <h2 class="heading-lg text-slate-900 font-bold leading-tight">{{ featuredArticle.title }}</h2>
      <p class="text-slate-600 text-lg leading-relaxed">{{ featuredArticle.description }}</p>
      <RouterLink
        :to="`/article/${featuredArticle.slug}`"
        class="inline-flex items-center px-6 py-3 bg-gradient-to-r from-blue-600 to-cyan-600 text-white font-semibold rounded-lg hover:from-blue-700 hover:to-cyan-700 transform hover:scale-105 transition-all duration-200 shadow-md hover:shadow-lg"
      >
        Read Full Article
        <svg class="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
        </svg>
      </RouterLink>
    </div>
  </section>
</template>

<script setup>
  import { computed } from 'vue';
  import { RouterLink } from 'vue-router';
  import { getAllArticles, getFeaturedArticles } from '@/utils/dataProcessor.js';

  // Get the first featured article, or fall back to the first article
  const featuredArticle = computed(() => {
    const allArticles = getAllArticles();
    const featured = getFeaturedArticles(allArticles, 1);
    return featured.length > 0
      ? featured[0]
      : allArticles.length > 0
      ? allArticles[0]
      : {
          imageBase64: 'https://loremflickr.com/800/450/tech',
          title: 'Featured Article Title',
          description: 'A short description of the featured article, highlighting its main points.',
          slug: 'featured-article',
        };
  });
</script>

<style scoped>
  /* Tailwind CSS handles all styling */
</style>
